/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import {
  type BaseQueryApi,
  createApi,
  type FetchArgs,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react'
import Cookies from 'js-cookie'
import { toast } from 'react-toastify'
import {
  BACKEND_BASE_URL,
  COOKIE_KEY,
  GOOD_ONLINE_BACKEND_BASE_URL,
  IMAGES_BACKEND_BASE_URL,
} from '../../constants'

const baseQuery = fetchBaseQuery({
  baseUrl: BACKEND_BASE_URL,
  prepareHeaders: (headers) => {
    const cookie = Cookies.get(COOKIE_KEY)
    const token = cookie
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    return headers
  },
})

const baseQueryWithReauth = async (
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: Record<string, unknown>,
): Promise<any> => {
  const result = await baseQuery(args, api, extraOptions)

  const isError = result.error?.status === 401
  // if token is expired
  if (isError) {
    Cookies.remove(COOKIE_KEY)
    localStorage.removeItem('persist:root')
    window.location.replace('/auth/login')
  }

  // If internal server error
  if (result.meta?.response?.status === 500) {
    toast.error('Internal server error')
  }

  return result
}

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'AFFILIATE',
    'AFFILIATE_COLLECTION',
    'AMBASSADOR',
    'ARTICLE',
    'AUDIT_LOG',
    'CART',
    'CATEGORY',
    'COMMENT',
    'CREATOR_VIDEO',
    'CURATED_PRODUCT',
    'CURATION_TYPE',
    'CUSTOMER',
    'DELIVERY_REGION',
    'DISCOUNT',
    'DISCOVER',
    'DISCOVER_CARD',
    'DISCOVER_WEIGHTS',
    'ESSENTIAL',
    'EVENT',
    'EVENT_TICKET',
    'FEE',
    'FULFILMENT_CENTRE',
    'HOMEPAGE_SECTION',
    'INTEREST',
    'INVESTOR',
    'LIST',
    'LIST_MENU',
    'LOCATION',
    'ORDER',
    'ORDER_METRICS',
    'ORIGIN',
    'PERMISSION',
    'PICKUP_LOCATION',
    'PLATFORM_COST',
    'PRODUCT',
    'PRODUCT_INVENTORY',
    'RATING',
    'REFERRAL',
    'REFUND',
    'REPORT',
    'ROLE',
    'SETTINGS',
    'SETTLEMENT',
    'SETTLEMENT_ACCOUNT',
    'SETTLEMENT_CONFIG',
    'SPENDING_QUESTION',
    'STAKEHOLDER',
    'SUBCATEGORY',
    'SUBVARIANT',
    'TAG',
    'TERMINAL',
    'TRANSACTION',
    'USER',
    'VARIANT',
    'VENDOR',
    'VENDOR_CURATION',
    'VENDOR_INVITE',
    'VOUCHER',
    'WALLET',
  ],
  endpoints: (builder) => ({}),
})

export const goodOnlineApiSlice = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: GOOD_ONLINE_BACKEND_BASE_URL,
  }),
  tagTypes: ['BANK', 'WAITLIST'],
  endpoints: (builder) => ({}),
  reducerPath: 'goodOnlineApi',
})

export const imagesApiSlice = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: IMAGES_BACKEND_BASE_URL,
  }),
  endpoints: (builder) => ({}),
  reducerPath: 'imagesApi',
})
